import * as React from 'react'
import * as st from './actionBox.module.scss'
import { Spinner } from 'DVWebNodeUI';

type WrapperComponent = { children?: React.ReactNode, className?: string }

export const DisableOverlay = ({ children = null, className = '' }: WrapperComponent) => (
  <div className={[className, st.disableOverlay].join(' ')}>
    {children}
  </div>
)

type PurchaseOverlayProps = { purchasingText?: string, useSmallSpinner?: boolean, className?: string }
export const PurchaseOverlay = ({ purchasingText, useSmallSpinner = false, className = '' }: PurchaseOverlayProps) => {

  return (
    <DisableOverlay className={className}>
      <div className={st.messageWrapper}>
        <div className={useSmallSpinner ? st.smallSpinnerWrapper : st.spinnerWrapper}><Spinner fillHeight /></div>
        {purchasingText && <div>{purchasingText}</div>}
      </div>
    </DisableOverlay>
  )
}